import { GET_NOTIFICATIONS } from '@/shared/api';
import type { AppDispatch } from '@/shared/config/storeConfig';
import { notificationsApi } from '../api/notificationsApi';

export const handleNotificationsUnreadCountUpdated = (
  dispatch: AppDispatch,
  count: number,
) => {
  dispatch(
    notificationsApi.util.upsertQueryData('getUnreadNotificationsCount', undefined, { count }),
  );
};

export const handleNotificationNew = (dispatch: AppDispatch) => {
  dispatch(notificationsApi.util.invalidateTags([GET_NOTIFICATIONS]));
};
